import { useState, useRef, useEffect } from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Toast from "./components/Toast";
import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";
import ShopPage from "./pages/ShopPage";
import ClassroomPage from "./pages/ClassroomPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import Feedbackpage from "./pages/Feedbackpage";
import FAQPage from "./pages/FAQpage";
import { API } from "./utils/media";
import "./styles/App.css";

export default function App() {
  const [page, setPage] = useState("home");
  const [shopItems, setShopItems] = useState([]);
  const [classItems, setClassItems] = useState([]);
  const [galleryItems, setGalleryItems] = useState([]);
  const [toast, setToast] = useState(null);
  const toastKey = useRef(0);
  const [feedbackItems, setFeedbackItems] = useState([]);

  useEffect(() => {
    fetch(API.list)
      .then((r) => r.json())
      .then((data) => {
        setShopItems(data.shop || []);
        setClassItems(data.classroom || []);
        setGalleryItems(data.gallery || []);
        setFeedbackItems(data.feedback || []);
      })
      .catch(() => {});
  }, []);

  function showToast(msg) {
    toastKey.current++;
    setToast({ msg, key: toastKey.current });
  }

  return (
    <div className="app">
      <div className="paper-bg" />
      <Nav page={page} setPage={setPage} />
      <main>
        {page === "home"      && <HomePage      setPage={setPage} shopItems={shopItems} galleryItems={galleryItems} feedbackItems={feedbackItems} />}
        {page === "about"     && <AboutPage />}
        {page === "gallery"   && <GalleryPage   galleryItems={galleryItems} />}
        {page === "shop"      && <ShopPage      shopItems={shopItems} />}
        {page === "classroom" && <ClassroomPage classItems={classItems} />}
        {page === "feedback"  && <Feedbackpage feedbackItems={feedbackItems} />}
        {page === "faq"       && <FAQPage />}
        {page === "admin"     && (
          <AdminPage
            shopItems={shopItems}   setShopItems={setShopItems}
            classItems={classItems} setClassItems={setClassItems}
            galleryItems={galleryItems} setGalleryItems={setGalleryItems}
            feedbackItems={feedbackItems} setFeedbackItems={setFeedbackItems}
            showToast={showToast}
          />
        )}
      </main>
      {page !== "admin" && <Footer setPage={setPage} />}
      {toast && (
        <Toast key={toast.key} msg={toast.msg} onClose={() => setToast(null)} />
      )}
    </div>
  );
}
